import { Sheet } from "react-modal-sheet";
import useWindowSize from "../../../../../hooks/useWindowSize";
import classNames from "classnames";
import Show from "../Show";

interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  disableDrag?: boolean;
}

const BottomSheet = ({
  open,
  onClose,
  children,
  disableDrag = false,
}: BottomSheetProps) => {
  const { size } = useWindowSize();
  const isDesktopView = (size?.width || 0) >= 768;

  return (
    <Sheet
      isOpen={open}
      onClose={onClose}
      detent="content-height"
      animate={!isDesktopView}
      className={classNames("w-auto m-auto", {
        "flex justify-center items-center": isDesktopView,
      })}
      disableDrag={disableDrag || isDesktopView}
    >
      <Sheet.Backdrop onTap={onClose} className={"bg-[rgba(0, 0, 0, 0.5]"} />
      {/* Mobile: round only the top — the sheet is flush to the viewport bottom,
          so the bottom corners must be square. Desktop is a floating modal (all 4). */}
      <Sheet.Container
        style={
          isDesktopView
            ? { left: "unset", bottom: "unset", borderRadius: 16 }
            : {
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
              }
        }
        className={classNames({
          "rounded-xl max-w-[600px]": isDesktopView,
          "rounded-t-xl rounded-b-none": !isDesktopView,
        })}
      >
        <Sheet.Header>
          <Show when={!isDesktopView}>
            <div className="flex flex-col items-center gap-y-2 justify-between py-[8px]">
              <div className="bg-slate-200 rounded-md h-[4px] w-[50px]" />
            </div>
          </Show>
        </Sheet.Header>
        <Sheet.Content className="mt-2">{children}</Sheet.Content>
      </Sheet.Container>
    </Sheet>
  );
};

export default BottomSheet;
